module.exports = __webpack_public_path__ + "static/media/retail-strip-plaza.585ee69a.svg";